import React from "react";

import PagerButton from "./PagerButton";

type PagerButtonProps = {
	disabled?: boolean;
	page: number;
	active?: boolean;
	children?: JSX.Element | JSX.Element | string | number;
	onPageChange: (newPage: number) => void;
};

export default function PageButton(props: PagerButtonProps & { page: number }) {
	return <PagerButton {...props}>{props.page}</PagerButton>;
}
